export enum RationSubType {
  FIBRES = 'fibres',
  PROTEIN = 'protein',
  ENERGY = 'energy',
  HIGH_FIBER = 'high_fiber',
  HIGH_FIBER_ENERGY = 'high_fiber_energy',
  HIGH_FIBER_PROTEIN = 'high_fiber_protein',
  MEDIUM_LOW_FIBER = 'medium_low_fiber',
  MINERAL = 'mineral',
}

export enum ForageSubType {
  FORAGES = 'forages',
  BALED = 'baled',
  SILAGE = 'silage',
  CROP_RESIDUE = 'crop_residue',
  FRESH = 'fresh',
  STRAW = 'straw',
  BY_PRODUCT = 'by_product',
  CEREALS = 'cereals',
  ROOT = 'root',
}

export enum ConcentrateSubType {
  FLAKED = 'flaked',
  FLOUR = 'flour',
  GRAIN = 'grain',
  GROUND = 'ground',
  BREADCRUMBS = 'breadcrumbs',
  SEED = 'seed',
  CORE = 'core',
  FEED = 'feed',
  COMPLEMENTARY_FEED = 'complementary_feed',
  MOLASSES = 'molasses',
  SUPPLEMENT = 'supplement',
  MASH = 'mash',
  OTHER = 'other',
}
